export var DIALOG_CLASS_PREFIX = 'Dialog';
export var dialogCloseButton = 'DialogCloseButton';
export var DIALOG_SCROLL_DOCUMENT = 'document';
export var DIALOG_SCROLL_DIALOG = 'dialog';